import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Layers, FileText } from "lucide-react";

export default function Categories() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/categories/stats");
        setCategories(data);
      } catch {}
    })();
  }, []);

  return (
    <div className="space-y-6" data-testid="categories-page">
      <h1 className="text-2xl md:text-3xl font-extrabold text-primary">الفئات</h1>
      <div className="bg-white rounded-lg border border-border shadow-[0_4px_20px_-4px_rgba(15,61,62,0.08)] overflow-hidden max-w-2xl" data-testid="categories-stats-card">
        <div className="flex items-center gap-2 bg-primary text-white px-5 py-3 font-bold">
          <Layers className="h-5 w-5" />
          إحصائية القرارات حسب الفئة
        </div>
        <table className="w-full text-sm" data-testid="categories-stats-table">
          <thead>
            <tr className="bg-muted text-primary">
              <th className="px-5 py-3 text-right font-bold">م</th>
              <th className="px-5 py-3 text-right font-bold">الفئة</th>
              <th className="px-5 py-3 text-right font-bold">عدد القرارات</th>
            </tr>
          </thead>
          <tbody>
            {categories.length === 0 ? (
              <tr><td colSpan={3} className="text-center py-8 text-muted-foreground" data-testid="categories-empty">لا توجد فئات</td></tr>
            ) : (
              categories.map((c, i) => (
                <tr key={c.id} className="border-t border-border hover:bg-muted/50 transition-colors" data-testid={`category-stat-row-${i}`}>
                  <td className="px-5 py-3">{i + 1}</td>
                  <td className="px-5 py-3 font-bold text-primary">{c.name}</td>
                  <td className="px-5 py-3">
                    <span className="inline-flex items-center gap-2 bg-secondary/15 text-secondary font-bold rounded-full px-3 py-1" data-testid={`category-count-${i}`}>
                      <FileText className="h-4 w-4" />
                      {c.decisions_count}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
